import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const ForgeSpacePageExtensionPoint: LoadableType<{
	spaceKey: string;
	appId: string;
	envId: string;
	forgeManifestRoute: string;
}> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-SpacePage" */ './SpacePage.tsx')).SpacePage,
});
